<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw preface-rw auto-rw page-open-left-rw" epub:type="frontmatter preface" id="preface003">
<h1 class="preface-title-s"><a id="page-viii"></a><span href="#/toc#toc-preface003" title="Link target outside of Sample">START CLOSE IN</span></h1>
<div class="ext">
<p class="blockquote-firstpara">Start close in,</p>
<p class="blockquote-firstpara">don’t take the second step</p>
<p class="blockquote-firstpara">or the third,</p>
<p class="blockquote-firstpara">start with the first</p>
<p class="blockquote-firstpara">thing</p>
<p class="blockquote-firstpara">close in,</p>
<p class="blockquote-firstpara">the step</p>
<p class="blockquote-firstpara">you don’t want to take.</p>
</div>
<div class="ext">
<p class="blockquote-firstpara">Start with</p>
<p class="blockquote-firstpara">the ground</p>
<p class="blockquote-firstpara">you know,</p>
<p class="blockquote-firstpara">the pale ground</p>
<p class="blockquote-firstpara">beneath your feet,</p>
<p class="blockquote-firstpara">your own</p>
<p class="blockquote-firstpara">way of starting</p>
<p class="blockquote-firstpara">the conversation.</p>
</div>
<div class="ext">
<p class="blockquote-firstpara">Start with your own</p>
<p class="blockquote-firstpara">question,</p>
<p class="blockquote-firstpara">give up on other</p>
<p class="blockquote-firstpara">people’s questions,</p>
<p class="blockquote-firstpara">don’t let them</p>
<p class="blockquote-firstpara">smother something</p>
<p class="blockquote-firstpara">simple.</p>
</div>
<div class="ext">
<p class="blockquote-firstpara">To find</p>
<p class="blockquote-firstpara">another’s voice,</p>
<p class="blockquote-firstpara">follow</p>
<p class="blockquote-firstpara">your own voice,</p>
<p class="blockquote-firstpara">wait until</p>
<p class="blockquote-firstpara">that voice</p>
<p class="blockquote-firstpara">becomes a</p>
<p class="blockquote-firstpara">private ear</p>
<p class="blockquote-firstpara">listening</p>
<p class="blockquote-firstpara">to another.</p>
</div>
<div class="ext">
<p class="blockquote-firstpara">Start right now</p>
<p class="blockquote-firstpara">take a small step</p>
<p class="blockquote-firstpara">you can call your own</p>
<p class="blockquote-firstpara">don’t follow</p>
<p class="blockquote-firstpara">someone else’s</p>
<p class="blockquote-firstpara">heroics, be humble</p>
<p class="blockquote-firstpara">and focused,</p>
<p class="blockquote-firstpara">start close in,</p>
<p class="blockquote-firstpara">don’t mistake</p>
<p class="blockquote-firstpara">that other</p>
<p class="blockquote-firstpara">for your own.</p>
</div>
<div class="fsq">
<p class="blockquote-firstpara"><em>Start close in,</em></p>
<p class="blockquote-firstpara"><em>don’t take</em></p>
<p class="blockquote-firstpara"><em>the second step</em></p>
<p class="blockquote-firstpara"><em>or the third,</em></p>
<p class="blockquote-firstpara"><em>start with the first</em></p>
<p class="blockquote-firstpara"><em>thing</em></p>
<p class="blockquote-firstpara"><em>close in,</em></p>
<p class="blockquote-firstpara"><em>the step</em></p>
<p class="blockquote-firstpara"><em>you don’t want to take</em></p>
<p class="attribution"><em>David Whyte</em></p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface003.vue?48a4303c